"use strict";

var assign = require('lodash/assign');

var RANDOM_OFFSET_PERCENT = 0.25;
var DEFAULT_DELAY = 500;
var DEFAULT_MAX_DELAY = 21600000;

function getNextDelay(delay, attemptCount) {
  var offset = parseInt(Math.random() * (delay * RANDOM_OFFSET_PERCENT), 10);
  return delay * (attemptCount + 1) + offset;
}

var noop = function noop() {};
/**
 * Exponential backoff helper for async functions. Generates a function that
 * accepts the async action to execute. Returns true if action is executed.
 * Returns false if `maxDelay` option value is surpassed.
 *
 * Backoff Algo is `(d * nt) + o`, where:
 *
 * d - the current delay value
 * nt - the current number of attempts
 * o - a random offset which is a random percentage of the current delay value
 *
 * @param  {object} options
 * @param  {object} options.delay     The initial delay after the first attempt.
 * @param  {object} options.maxDelay  The maximum delay for the algo. Returns
 *                                    false if reached.
 */


var async = function async(options) {
  var opts = assign({
    delay: DEFAULT_DELAY,
    maxDelay: DEFAULT_MAX_DELAY,
    attemptCount: 0
  }, options);
  return function (action) {
    if (opts.attemptCount === 0) {
      opts.attemptCount += 1;
      action();
      return true;
    }

    if (opts.delay <= opts.maxDelay) {
      setTimeout(function () {
        action();
      }, opts.delay);
      opts.delay = getNextDelay(opts.delay, opts.attemptCount);
      opts.attemptCount += 1;
      return true;
    }

    return false;
  };
};
/**
 * Exponential backoff helper for synchronous functions. Executes
 * `options.success` if test passes, otherwise `options.error` if the maximum
 * delay is reached.
 *
 * @param  {function} test    function that returns true when retries are no
 *                            longer necessary.
 * @param  {object} options
 * @param  {object} options.success   The test passed before maxDelay was reached.
 * @param  {object} options.failure   The test failed to pass before maxDelay
 *                                    was reached.
 * @param  {object} options.delay     The initial delay after the first attempt.
 * @param  {object} options.maxDelay  The maximum delay for the algo. Returns
 *                                    false if reached.
 */


var sync = function sync(test, options) {
  var opts = assign({
    success: noop,
    failure: noop
  }, options);
  var next = async(opts);

  var doTest = function doTest() {
    if (test()) {
      opts.success();
    } else if (!next(function () {
      return doTest();
    })) {
      opts.failure();
    }
  };

  doTest();
};

module.exports = {
  sync: sync,
  async: async
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/request/lib/back-off.js
// module id = 688
// module chunks = 0 1